import { useState, useCallback, useEffect } from 'react';
import { getCurrencies, convertCurrency, convertCurrencyOnDate } from '../../services/api';

export function useConverter() {
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [resultUpdated, setResultUpdated] = useState(false);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await getCurrencies();
        const currencies = response?.value || [];
        setCurrencyOptions(currencies.map(currency => ({ code: currency.code })));
      } catch (err) {
        setError('Failed to load currencies');
      }
    };

    fetchCurrencies();
  }, []);

  const convert = useCallback(async (amount, baseCurrency, targetCurrency, date = null) => {
    setLoading(true);
    setError(null);
    setResultUpdated(false);

    try {
      const currencies = `${baseCurrency}${targetCurrency}`;
      
      let response;
      if (date) {
        response = await convertCurrencyOnDate({
          date: date.toISOString().split('T')[0],
          currencies,
          amount
        });
      } else {
        response = await convertCurrency(amount, currencies);
      }

      const convertedAmount = response.data?.value ?? response.data ?? 0;
      
      if (convertedAmount === 0 || convertedAmount === null || convertedAmount === undefined) {
        setError(`Unable to convert ${baseCurrency} to ${targetCurrency}. Rate not available.`);
        setResult(0);
        return 0;
      }
      
      setResult(convertedAmount);
      setResultUpdated(true);
      
      return convertedAmount;
    } catch (err) {
      const errorMessage = err.message || 'Conversion failed. Please try again.';
      setError(errorMessage);
      setResult(0);
      throw err;
    } finally {
      setLoading(false);
      setTimeout(() => setResultUpdated(false), 500);
    }
  }, []);

  return {
    currencyOptions,
    loading,
    error,
    result,
    resultUpdated,
    convert
  };
}
